// extracted by mini-css-extract-plugin
module.exports = {"light":"Header_light__1AC7f","dark":"Header_dark__fsqKr","container":"Header_container__3t2Bo"};